import Headcount from '@/components/Headcount.vue';
import { useCartStore } from '@/stores/cart';
import { useConfigStore } from '@/stores/config';
import { useModalStore } from '@/stores/modal';

export function useCart() {
  const configStore = useConfigStore();
  const modalStore = useModalStore();
  const cartStore = useCartStore();

  /**
   * 인원 수 검사 후 입력되어 있지 않다면 모달을 열어 인원 수를 입력 받은 후 성공 여부 반환. 인원 수 입력 옵션을 사용하지 않는 경우 항상 true 반환
   * @returns 성공 여부
   */
  const ensureHeadcountAsync = async (): Promise<boolean> => {
    if (!configStore.config.IsHeadcountInputUsed) return true;
    if (cartStore.cart.Headcount) return true;

    const headcount = await modalStore.openSyncModalAsync<typeof Headcount, number>(Headcount, {});
    if (headcount > 0) {
      cartStore.setHeadcount(headcount);
      return true;
    }
    return false;
  };

  return {
    ensureHeadcountAsync,
  };
}
